exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-button--primary[data-v-15eb5135],.el-button--primary[data-v-15eb5135]:active,.el-button--primary[data-v-15eb5135]:focus,.el-button--primary[data-v-15eb5135]:hover{background-color:#4caf50;border-color:#4caf50}.el-button--primary.is-disabled[data-v-15eb5135],.el-button--primary.is-disabled[data-v-15eb5135]:active,.el-button--primary.is-disabled[data-v-15eb5135]:focus,.el-button--primary.is-disabled[data-v-15eb5135]:hover{background-color:#4caf50;border-color:#4caf50;opacity:.5}.dashboard-empty[data-v-15eb5135]{text-align:center;width:100%}.dashboard-empty img[data-v-15eb5135]{height:80px;width:auto}", ""]);

// exports
